// Enum as Both Keys and Values
// LoginModalPage[0] would return "EmailInput"
// LoginModalPage["EmailInput"] would return 0

export enum LoginModalPage {
  EmailInput,
  OtpInput,
  NameInput,
}

// Enum as Both Keys and Values
export enum WebformPage {
  FormDetails,
  ContactDetails,
  SummaryPage,
  SuccessPage,
}
